module.exports = __webpack_public_path__ + "media/images/text_message_empty-c482ab20a7ad7a4df348d69310821514.svg";